const TribalIcon = () => {
    return (
        <div className="w-5">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="45 25 110 270" fill="none">
                <path d="M100 30 L100 230 M100 90 L55 60 M100 90 L145 60 M100 150 L55 120 M100 150 L145 120 M100 210 L55 180 M100 210 L145 180 M100 230 L55 260 L100 290 L145 260 Z"
                    stroke="#ffffff" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    );
}

export default TribalIcon